import orderApprovalDetailsReducer, {
    OrderApprovalDetailsActions,
} from "@store/Framework/Store/Store/Pages/OrderApprovalDetails/OrderApprovalDetailsReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    orderApprovalDetails: orderApprovalDetailsReducer,
};

export type StorePagesActions = OrderApprovalDetailsActions;
export default combineReducers(pagesReducers);
